export const env = {
    produrl: "https://api.neoindus.neoauralabs.com/api/v1",
    //produrl: "http://127.0.0.1:8000/api/v1",
}